import _ from 'lodash';

export default class CustomerLookupConfigurationService {
  constructor(publisher, getDb) {
    this.publisher = publisher;
    this.getDatabase = getDb;
  }

  getStatus(orgId) {
    const config = this.get(orgId);
    return getStatusFromConfig(config);
  }

  get(orgId) {
    let customerLookup = this.getDatabase(orgId).customerLookup;
    return _.isPlainObject(customerLookup)
      ? customerLookup
      : { errors: [{ code: 'not_exist', detail: 'configuration value [customer-lookup] does not exist' }] };
  }

  update(orgId, { correlationId, payload }) {
    let updatedCustomerLookup = _.merge(this.getDatabase(orgId).customerLookup || {}, payload);
    this.getDatabase(orgId).customerLookup = updatedCustomerLookup;
    this.publisher.publishCustomerLookupConfig(correlationId, orgId, updatedCustomerLookup);
    this.publisher.publishExternalCustomerLookupStatus(
      correlationId,
      orgId,
      getStatusFromConfig(updatedCustomerLookup)
    );
  }

  static create(pubsub, getDb) {
    return new CustomerLookupConfigurationService(new CustomerLookupConfigurationPublisher(pubsub), getDb);
  }
}

function getStatusFromConfig(config) {
  if (!_.isEmpty(config.errors)) {
    return { status: 'NOT_CONFIGURED' };
  }

  if (config.disabled) {
    return { status: 'DISABLED' };
  }

  return { status: 'OK' };
}

export class CustomerLookupConfigurationPublisher {
  constructor(pubsub) {
    this.pubsub = pubsub;
  }

  publishCustomerLookupConfig(correlationId, orgId, customerLookupConfig) {
    this.pubsub.publish(`v1/orgs/${orgId}/configuration/customer-lookup`, {
      correlationId,
      payload: customerLookupConfig,
    });
  }

  publishExternalCustomerLookupStatus(correlationId, orgId, status) {
    this.pubsub.publish(`v1/orgs/${orgId}/external-customer-lookup-status`, {
      correlationId,
      payload: status,
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/infrastructure/backends/fake_backend/customer_lookup_configuration_service.js